module.exports = __webpack_public_path__ + "img/fr.561d8c4f.svg";